// internet explorer
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";

import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect, withRouter, useLocation } from "react-router-dom";

// components
import { About, Home, Service, Portfolio, Customer, Media, Page404 } from "pages";
import { AdminSignin, AdminHome, AdminAbout, AdminPortfolio, AdminRecruit, AdminCustomer } from "admin";
import { HeaderAdmin, AdminMenu } from "admin/components";
import { Header, Menu, Loading } from "components/items";
import { BtnIcon } from "components/btns";

// image
import ic_kakao from "image/icon/ic_kakao.png";

// style
import "scss/App.scss";

// library
import firebase from "library/firebase-config.js";
import "firebase/auth";

const auth = firebase.auth();

let didScrollAction = null;

export const authContext = React.createContext();

// field
const KAKAO_URL = "https://pf.kakao.com/_KClbV";

function App(props) {
	// menu field
	const [isMenuClicked, setMenu] = useState(false);
	const [showHeader, setHeader] = useState(false);
	const [redirectToLogin, setRedirectToLogin] = useState(false);

	const [isLoading, setIsLoading] = useState(true);
	const [isLogoLoading, setIsLogoLoading] = useState(true);
	const [isPfLoading, setIsPfLoading] = useState(false);
	const [isMediaLoading, setMediaLoading] = useState(false);
	const [isBoardLoading, setIsBoardLoading] = useState(false);
	const [isMemberLoading, setIsMemberLoading] = useState(false);
	const [isDetail, setIsDetail] = useState(false);

	useEffect(() => {
		if (isLogoLoading || isPfLoading || isMediaLoading || isBoardLoading || isMemberLoading) {
			setIsLoading(true);
		} else {
			setIsLoading(false);
		}
	}, [isLogoLoading, isPfLoading, isMediaLoading, isBoardLoading, isMemberLoading]);

	const nowURL = useLocation().pathname;
	const isAdmin = () => {
		if (nowURL.split("/")[1] === "admin") {
			document.body.classList.add("admin");
			return true;
		} else {
			return false;
		}
	};
	const [checkAdmin, setCheckAdmin] = useState(isAdmin());

	// authorization
	const checkUser = () => {
		auth.onAuthStateChanged((me) => {
			if (me) {
				setRedirectToLogin(false);
			} else {
				setRedirectToLogin(true);
			}
		});
	};

	const scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	const menuClickHandler = () => {
		setMenu(!isMenuClicked);
	};

	useEffect(() => {
		checkUser();
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", detectingScroll);
	}, []);

	const detectingScroll = () => {
		if (didScrollAction) {
			clearTimeout(didScrollAction);
		}

		didScrollAction = setTimeout(() => {
			// event
			const st = window.pageYOffset || document.documentElement.scrollTop;
			if (st < 200) {
				// downscroll code
				setHeader(false);
			} else {
				// upscroll code
				setHeader(true);
			}
		}, 100);
	};

	props.history.listen(() => {
		scrollToTop();
		setCheckAdmin(isAdmin());
		if (!!props.history.location.query) {
			setIsDetail(true);
		} else {
			setIsDetail(false);
		}
	});

	return (
		<div className="App">
			{!checkAdmin ? <Loading className={isLoading ? `` : "hide"} /> : ""}

			<authContext.Provider value={{ redirectToLogin, setIsLogoLoading, setIsPfLoading, setMediaLoading, setIsBoardLoading, setIsMemberLoading, isDetail, setIsDetail }}>
				{!checkAdmin ? (
					<Header type="default" menuClickHandler={menuClickHandler} isMenuClicked={isMenuClicked} showHeader={showHeader} />
				) : (
					<HeaderAdmin type="header-type-main" menuClickHandler={menuClickHandler} isMenuClicked={isMenuClicked} setMenu={setMenu} />
				)}

				{!checkAdmin ? <Menu isMenuClicked={isMenuClicked} setMenu={setMenu} /> : <AdminMenu isMenuClicked={isMenuClicked} setMenu={setMenu} />}

				{!checkAdmin ? <BtnIcon image={ic_kakao} className="btn-floating kakao" href={KAKAO_URL} target="_blank" /> : ""}

				<Switch>
					{/* page */}
					<Route exact path="/" component={Home} />
					<Route exact path="/about" component={About} />
					<Route path="/about/media" component={Media} />
					<Route path="/service" component={Service} />
					<Route path="/portfolio" component={Portfolio} />
					{/* <Route exact path="/recruit" component={Recruit} /> */}
					<Route exact path="/customer" component={Customer} />

					{/* <Route exact path="/recruit/staff" render={() => <Board gnb="recruit" lnb="staff" />} />
					<Route exact path="/recruit/manager" render={() => <Board gnb="recruit" lnb="manager" />} />
					<Route exact path="/customer/notice" render={() => <Board gnb="customer" lnb="notice" />} />
					<Route exact path="/customer/qna" render={() => <Board gnb="customer" lnb="qna" />} /> */}

					{/* <Route exact path="/recruit/staff/:name" render={({ match, location }) => <BoardDetail match={match} location={location} gnb="recruit" lnb="staff" />} /> */}
					{/* <Route exact path="/recruit/manager/:name" render={({ match, location }) => <BoardDetail match={match} location={location} gnb="recruit" lnb="manager" />} /> */}
					{/* <Route exact path="/customer/notice/:name" render={({ match, location }) => <BoardDetail match={match} location={location} gnb="customer" lnb="notice" />} /> */}
					{/* <Route exact path="/customer/qna/:name" render={({ match, location }) => <BoardDetail match={match} location={location} gnb="customer" lnb="qna" />} /> */}

					{/* admin */}

					<Route exact path="/admin" render={() => (!redirectToLogin ? <Redirect to="/admin/home" /> : <AdminSignin />)} />
					<Route path="/admin/home" render={() => (redirectToLogin ? <Redirect to="/admin" /> : <AdminHome />)} />
					<Route path="/admin/about" render={() => (redirectToLogin ? <Redirect to="/admin" /> : <AdminAbout />)} />
					<Route path="/admin/portfolio" render={() => (redirectToLogin ? <Redirect to="/admin" /> : <AdminPortfolio />)} />
					<Route path="/admin/recruit" render={() => (redirectToLogin ? <Redirect to="/admin" /> : <AdminRecruit />)} />
					<Route path="/admin/customer" render={() => (redirectToLogin ? <Redirect to="/admin" /> : <AdminCustomer />)} />

					{/* 404 */}
					<Route component={Page404} />
				</Switch>
			</authContext.Provider>
		</div>
	);
}

export default withRouter(App);
